(() => {
  const corporateMode = "corporate";
  const personalMode = "personal";
  const corporateHomePath = "/pages/corporate-gifting";
  const corporateExplorePath = "/corporate-gifting/menu";
  const corporateSearchPath = "/corporate-gifting/search";
  const personalExplorePath = "/menu";
  const personalSearchPath = "/search";

  const getMode = () => {
    const pageMode = document.querySelector("[data-clean-page-mode]")?.dataset
      .cleanPageMode;
    return pageMode === corporateMode ? corporateMode : personalMode;
  };

  const normalizePath = (value) => {
    try {
      return (
        new URL(value, window.location.origin).pathname.replace(/\/+$/, "") ||
        "/"
      );
    } catch (error) {
      return "/";
    }
  };

  const setCurrentPage = (link, isCurrent) => {
    if (isCurrent) {
      link.setAttribute("aria-current", "page");
    } else {
      link.removeAttribute("aria-current");
    }
  };

  const applyMode = (mode = getMode(), root = document) => {
    const isCorporate = mode === corporateMode;
    const currentPath = normalizePath(window.location.pathname);
    const rootUrl = document.documentElement.dataset.cleanStoreRootUrl || "/";
    const homeUrl = rootUrl;
    const exploreUrl = isCorporate ? corporateExplorePath : personalExplorePath;
    const searchUrl = isCorporate ? corporateSearchPath : personalSearchPath;

    document.documentElement.dataset.cleanStoreMode = isCorporate
      ? corporateMode
      : personalMode;

    root.querySelectorAll("[data-clean-page-mode]").forEach((page) => {
      page.dataset.cleanPageMode = mode;
    });

    root
      .querySelectorAll("[data-clean-store-mode-option]")
      .forEach((option) => {
        option.setAttribute(
          "aria-pressed",
          String(option.dataset.cleanStoreModeOption === mode),
        );
      });

    root.querySelectorAll("[data-clean-context-home-link]").forEach((link) => {
      link.href = homeUrl;

      if (link.closest(".clean-mobile-nav")) {
        setCurrentPage(link, currentPath === normalizePath(homeUrl));
      }
    });

    root
      .querySelectorAll("[data-clean-context-explore-link]")
      .forEach((link) => {
        link.href = exploreUrl;
        setCurrentPage(link, currentPath === exploreUrl);
      });

    root
      .querySelectorAll("[data-clean-context-search-link]")
      .forEach((link) => {
        link.href = searchUrl;
        setCurrentPage(link, currentPath === searchUrl);
      });
  };

  const navigateForMode = (mode, toggle) => {
    const fallbackUrl = mode === corporateMode ? corporateHomePath : "/";
    const destination =
      mode === corporateMode
        ? toggle.dataset.corporateUrl || fallbackUrl
        : toggle.dataset.personalUrl || fallbackUrl;

    applyMode(mode);
    window.location.assign(destination);
  };

  document.addEventListener("click", (event) => {
    const option = event.target.closest("[data-clean-store-mode-option]");
    if (!option) return;

    const toggle = option.closest("[data-clean-store-mode-toggle]");
    if (!toggle) return;

    navigateForMode(option.dataset.cleanStoreModeOption, toggle);
  });

  document.addEventListener("clean:header:rendered", () => applyMode());
  document.addEventListener("shopify:section:load", (event) =>
    applyMode(getMode(), event.target),
  );
  applyMode();
})();
